module.exports = __webpack_public_path__ + "static/media/Icon_9D1E14.20ecdead.png";